import ManageMFA from './ManageMFA';
export { ManageMFA };
export default ManageMFA;
